import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FC, useState } from "react";

import styles from "./topbarNotification.module.scss";

type TTopbarNotificationProps = { 
    message: string,
    onYesClick?: () => void,
    onNoClick?: () => void,
    otherButtonText?: string,
    onOtherButtonClick?: () => void
    doHideCloseButton?: boolean,
    className?: string,
    onMoreInfoClick?: () => void,
}

export const TopbarNotification: FC<TTopbarNotificationProps> = ({message, onYesClick, onNoClick, doHideCloseButton,
        otherButtonText, onOtherButtonClick, className, onMoreInfoClick}: TTopbarNotificationProps) => {

    const [isHidden, setIsHidden] = useState(false);

    const hideBar = () => {
        setIsHidden(true);
    };

    if(isHidden) return null;

    return (
        <div className={`${styles.topbarNotification} ${className ? className : ""}`}>
            <span>{message}</span>
            {onMoreInfoClick ? 
                <span className={styles.moreInfoButton} onClick={onMoreInfoClick}>more info</span>
                : null}

            {onYesClick ?
                <button className={`yes-button ${styles.button}`} onClick={onYesClick}>Yes</button>
                : null}
            {onNoClick ?
                <button className={`no-button ${styles.button}`} onClick={onNoClick}>No</button>
                : null}
            {otherButtonText && onOtherButtonClick ?
                <button className={`other-button ${styles.button}`} onClick={onOtherButtonClick}>{otherButtonText}</button>
                : null}
            
            {doHideCloseButton ? null : <span onClick={hideBar} className={styles.closeTimes}><FontAwesomeIcon icon={faTimes} /></span> }
        </div>
    );
};